import React, { Component } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';
import axios from 'axios';

const API_URL = backend_url['api_url'];
var Plotly = require('plotly.js');
var Plot = createPlotlyComponent(Plotly);

class InspectedSchools extends Component {
    constructor(props) {
		super(props);
		
		this.state = {
		   Graph_Data: [],
		   school_id: window.sessionStorage.getItem("school_id"),
		   bearer_auth: window.sessionStorage.getItem('token'),
		   loading: true,
		   error: null,
		   chartReady: false
		};
	}
	  
	componentDidMount() {
		const { school_id, bearer_auth } = this.state;
		
		if (!school_id || school_id === 'undefined' || school_id === 'null') {
			this.setState({ 
				error: 'No school ID available',
				loading: false 
			});
			return;
		}
		
		// Use the school inspection stats endpoint
		axios.get(`${API_URL}/school_inspection_stats/${school_id}`, 
			{ headers: { "Authorization": `Bearer ${bearer_auth}` } }
		).then(response => {
			console.log('Inspection stats received:', response.data);
			const data = response.data.data || [];
			
			this.setState({
				Graph_Data: data,
				loading: false,
				chartReady: true
			}, () => {
				// Force a re-render after data is set
				this.forceUpdate();
			});
		}).catch(error => {
			console.error('Error fetching inspection stats:', error);
			
			if (error.response?.status === 401) {
				swal({
					title: "",
					text: "Your session has expired. You'll automatically be logged out within seconds.",
					icon: "error",
					timer: 1250
				}).then(() => {
					window.sessionStorage.clear();
					window.location.reload();
				});
			} else {
				this.setState({ 
					error: 'Failed to load inspection statistics',
					loading: false,
					chartReady: true
				});
			}
		});
	}
	  
    render() {
		const { Graph_Data, loading, error, chartReady } = this.state;
		
		if (loading) {
			return (
				<div className="text-center p-5">
					<div className="spinner-border text-primary" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<p className="mt-2">Loading inspection statistics...</p>
				</div>
			);
		}
		
		if (error) {
			return (
				<div className="text-center p-5">
					<h5 className="text-danger">{error}</h5>
					<p>Unable to load inspection data.</p>
				</div>
			);
		}
		
		if (!Graph_Data || Graph_Data.length === 0) {
			return (
				<div className="text-center p-5">
					<h5>No Inspection Data Available</h5>
					<p>This school has not been inspected yet.</p>
				</div>
			);
		}
		
		// Debug: Show data in a table to verify it's displaying
		return (
			<React.Fragment>
				{/* Debug table - remove after confirming data displays */}
				<div className="mb-4 p-3 bg-light border rounded">
					<h6>Debug: Raw Inspection Data</h6>
					<table className="table table-sm table-bordered">
						<thead>
							<tr>
								<th>Year</th>
								<th>Visit Count</th>
								<th>Sector ID</th>
							</tr>
						</thead>
						<tbody>
							{Graph_Data.map((item, index) => (
								<tr key={index}>
									<td>{item.YEAR}</td>
									<td>{item.visit_count}</td>
									<td>{item.sector_id}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				
				{/* Plotly Chart */}
				<div style={{ width: '100%', height: '400px', minHeight: '400px' }}>
					<Plot
						data={[{
							type: 'bar',
							x: Graph_Data.map(item => item.YEAR).sort(),
							y: Graph_Data.map(item => parseInt(item.visit_count) || 0).sort((a,b) => a - b),
							marker: { color: '#3498db' },
							name: 'Inspections'
						}]}
						layout={{
							title: 'SCHOOL INSPECTION HISTORY',
							xaxis: { title: 'YEAR' },
							yaxis: { title: 'NUMBER OF INSPECTIONS' },
							autosize: true,
							height: 400
						}}
						useResizeHandler={true}
						style={{ width: '100%', height: '100%' }}
						config={{ responsive: true, displaylogo: false }}
					/>
				</div>
			</React.Fragment>
		);
	}
}

export default InspectedSchools;